<template>
  <div id="root">
    <Header v-bind='globalProps'/>
    <div class="main-content">
      <router-view v-bind='globalProps'/>
    </div>
    <Footer v-bind='globalProps'/>
  </div>
</template>

<script>
import { AmplifyEventBus, components } from 'aws-amplify-vue';
import { Auth } from 'aws-amplify';
import Header from '@/components/Header';
import Footer from '@/components/Footer';

export default {
  name: 'app',
  components: {
    ...components,
    Header,
    Footer,
  },
  data: () => {
    return {
      userInfo: {},
    };
  },
  computed: {
    globalProps() {
      return {
        userInfo: this.userInfo,
        isSignedIn: this.userInfo.attributes !== undefined,
      }
    },
  },
  methods: {
    updateUserInfo() {
      Auth.currentAuthenticatedUser().then((user) => {
        this.userInfo = user;
      }).catch(() => {
        this.userInfo = {};
      });
    },
  },
  created() {
    AmplifyEventBus.$on('authState', info => {
      if (info === 'signedOut') {
        if (this.$route.path !== '/') {
          this.$router.replace('/');
        }
      }

      this.updateUserInfo();
    });

    this.updateUserInfo();
  },
}
</script>

<style>
.main-content {
  min-height: 90vh;
}
</style>